import axios from "axios";
import { API_END_POINT } from "../../../constants/api";

const authConfig = () => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("usertoken")}`,
  },
});

export function addCompanyMember(memberData) {
  return axios.post(
    `${API_END_POINT}/company/member/add`,
    memberData,
    authConfig()
  );
}

export function getCompanyMembers(companyId) {
  return axios.get(
    `${API_END_POINT}/company/member/get/${companyId}`,
    authConfig()
  );
}

export function updateCompanyMember(memberId, companyId, data) {
  return axios.put(
    `${API_END_POINT}/company/member/update/${memberId}/${companyId}`,
    data,
    authConfig()
  );
}

export function deleteCompanyMember(memberId, companyId) {
  return axios.delete(
    `${API_END_POINT}/company/member/delete/${memberId}/${companyId}`,
    authConfig()
  );
}
